import { MolhamSingleTargetable, TComment } from "apiTypes";
import { useRouter } from "next/router";
import { PropsWithChildren, createContext, useEffect, useState } from "react";
type DonateDetailsContextType = {
  commentsTab: boolean;
  setCommentsTab: (val: boolean) => void;
  replyTab: TComment | null;
  setReplyTab: (comment: TComment) => void;
  showDonationInput: boolean;
  setShowDonationInput: (val: boolean) => void;
  setReactingCounts: (val: any) => void;
  reactingCounts: any;
};
const DonateDetailsContext = createContext<DonateDetailsContextType>(null);
type Props = PropsWithChildren<{
  data: MolhamSingleTargetable;
}>;
const DonateDetailsProvider = ({ children, data }: Props) => {
  const [reactingCounts, setReactingCounts] = useState({
    comments_count: data?.counters?.comments,
  });
  const { asPath } = useRouter();
  useEffect(() => {
    setReactingCounts((prev) => ({
      ...prev,
      comments_count: data?.counters?.comments,
    }));
  }, [asPath, data?.counters?.comments]);

  const [commentsTab, setCommentsTab] = useState(false);
  const [replyTab, setReplyTab] = useState<TComment | null>(null);
  const [showDonationInput, setShowDonationInput] = useState(false);

  return (
    <DonateDetailsContext.Provider
      value={{
        commentsTab,
        setCommentsTab,
        replyTab,
        setReplyTab,
        showDonationInput,
        setShowDonationInput,
        setReactingCounts,
        reactingCounts,
      }}
    >
      {children}
    </DonateDetailsContext.Provider>
  );
};

export { DonateDetailsContext, DonateDetailsProvider };
